'use client';

import { useRef, useState } from 'react';

import { HeycarImage } from '@core/Components/HeycarImage/HeycarImage';
import { Typography } from '@gds/Typography/Typography';
import { useImageCarousel } from '@shared-components/ImageCarousel/Hooks/UseImageCarousel';
import { Strings } from '@shared-components/ImageCarousel/ImageCarousel.entity';

import { GalleryMessages } from '../../Gallery/Gallery.messages';
import GalleryContainer from '../../Gallery/GalleryContainer';
import SlideshowGallery from '../../Gallery/SlideshowGallery/SlideshowGallery';

import styles from './Faults.module.css';

export const FaultsClient = ({
  faults,
  imageCarouselStrings,
  galleryStrings,
}: {
  faults: Record<string, any>[];
  imageCarouselStrings: Strings;
  galleryStrings: GalleryMessages;
}) => {
  const [isGalleryOpen, setIsGalleryOpen] = useState(false);
  const [currentClickImgIndex, setCurrentClickImgIndex] = useState<number | null>(null);
  const carouselRef = useRef<HTMLDivElement>(null);
  const carouselProps = useImageCarousel(carouselRef);
  const images = faults.map(fault => ({
    url: fault.image,
    altText: `Image of fault: ${fault.faultDescription}`,
    isRelative: false,
  }));

  const handleCardClick = (index: number) => {
    setCurrentClickImgIndex(index);
    setIsGalleryOpen(true);
  };
  return (
    <>
      <div className={styles.wrpr}>
        {faults.map(
          (
            {
              image,
              vehicleFaultId,
              faultDescription,
              actionDescription,
              faultLocationDescription,
            },
            i,
          ) => (
            <section
              key={vehicleFaultId}
              className={styles.faultCard}
              onClick={() => handleCardClick(i)}
            >
              <HeycarImage
                src={image}
                className={styles.img}
                alt={`Image of fault: ${faultDescription}`}
                sizes="200px"
              />
              <Typography Component="h5" variant="h6">
                {faultLocationDescription}
              </Typography>
              <Typography variant="subheading3">{faultDescription}</Typography>
              <Typography variant="body4">{actionDescription}</Typography>
            </section>
          ),
        )}
      </div>
      {isGalleryOpen && (
        <GalleryContainer
          images={images}
          galleryStrings={galleryStrings}
          locale={'uk'}
          currentIndex={currentClickImgIndex || 0}
          step={2}
          setStep={() => null}
          onBackButtonClick={() => setIsGalleryOpen(false)}
        >
          <SlideshowGallery
            slideshowGalleryStrings={imageCarouselStrings}
            images={images}
            currentClickImgIndex={currentClickImgIndex || 0}
            carouselProps={carouselProps}
            locale={'uk'}
            isZoomEnabled
          />
        </GalleryContainer>
      )}
    </>
  );
};
